"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resizeDependencies = void 0;

var _dependenciesMatrixGenerated = require("./dependenciesMatrix.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var resizeDependencies = {
  matrixDependencies: _dependenciesMatrixGenerated.matrixDependencies,
  createResize: _factoriesAny.createResize
};
exports.resizeDependencies = resizeDependencies;